import { __module as i } from "./chunk757.js";
import { __require as A } from "./chunk648.js";
var q = i.exports, _;
function L() {
  return _ ? i.exports : (_ = 1, function(d, y) {
    (function(p, v) {
      d.exports = v(A());
    })(q, function(p) {
      return function() {
        var v = p, m = v.lib, l = m.WordArray, x = v.enc;
        x.Base64url = {
          /**
           * Converts a word array to a Base64url string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @param {boolean} urlSafe Whether to use url safe
           *
           * @return {string} The Base64url string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
           */
          stringify: function(t, n) {
            n === void 0 && (n = !0);
            var s = t.words, o = t.sigBytes, e = n ? this._safe_map : this._map;
            t.clamp();
            for (var r = [], a = 0; a < o; a += 3)
              for (var f = s[a >>> 2] >>> 24 - a % 4 * 8 & 255, c = s[a + 1 >>> 2] >>> 24 - (a + 1) % 4 * 8 & 255, C = s[a + 2 >>> 2] >>> 24 - (a + 2) % 4 * 8 & 255, g = f << 16 | c << 8 | C, u = 0; u < 4 && a + u * 0.75 < o; u++)
                r.push(e.charAt(g >>> 6 * (3 - u) & 63));
            var h = e.charAt(64);
            if (h)
              for (; r.length % 4; )
                r.push(h);
            return r.join("");
          },
          /**
           * Converts a Base64url string to a word array.
           *
           * @param {string} base64Str The Base64url string.
           *
           * @param {boolean} urlSafe Whether to use url safe
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
           */
          parse: function(t, n) {
            n === void 0 && (n = !0);
            var s = t.length, o = n ? this._safe_map : this._map, e = this._reverseMap;
            if (!e) {
              e = this._reverseMap = [];
              for (var r = 0; r < o.length; r++)
                e[o.charCodeAt(r)] = r;
            }
            var a = o.charAt(64);
            if (a) {
              var f = t.indexOf(a);
              f !== -1 && (s = f);
            }
            return B(t, s, e);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
          _safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
        };
        function B(t, n, s) {
          for (var o = [], e = 0, r = 0; r < n; r++)
            if (r % 4) {
              var a = s[t.charCodeAt(r - 1)] << r % 4 * 2, f = s[t.charCodeAt(r)] >>> 6 - r % 4 * 2, c = a | f;
              o[e >>> 2] |= c << 24 - e % 4 * 8, e++;
            }
          return l.create(o, e);
        }
      }(), p.enc.Base64url;
    });
  }(i), i.exports);
}
export {
  L as __require
};
